import { ITSArrayListMaybeReadonly } from '../base';

export type ITSEmptyTuple = ITSArrayListMaybeReadonly<never>;
